import { withApnBesideYearBuilt } from '../../../shared';
import type { LandlordLocaleOverrides } from '../base';

export const CAOverrides: LandlordLocaleOverrides = {
  locale: 'CA',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: withApnBesideYearBuilt,
          fields: {
            assessorParcelNumber: {
              name: 'property.assessorParcelNumber',
              entity: 'property',
              type: 'text',
              label: 'APN Number',
              placeholderText: '',
            },
          },
        },
      },
    },
  },
};
